import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UpdateUser, UpdateUserResponse, UserResponse } from '../types';
import environment from '@environments/environment';

@Injectable()
export class UserService {
  private readonly _http = inject(HttpClient);
  loadUserList(url: string, params: HttpParams) {
    return this._http.get<UserResponse>(`${url}`, {
      params: params,
    });
  }

  updateUser(userObject: UpdateUser, userId: any) {
    return this._http.put<UpdateUserResponse>(
      `${environment.irisApi}/auth/user/${userId}/`,
      userObject,
    );
  }
}
